var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"page-container"},[_vm._v("404 "),_c('br'),_vm._v(" page not found")])])
}]

export { render, staticRenderFns }